export default "__VITE_ASSET__DTm6R$cc__"